import { AccountBox } from 'material-ui-icons';
import Button from 'material-ui/Button';
import Card, { CardActions, CardContent, CardHeader } from 'material-ui/Card';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Input, { InputLabel } from 'material-ui/Input';
import { CircularProgress } from 'material-ui/Progress';
import React from 'react';
import { translate } from 'react-i18next';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { getAccountName } from '../Utils/UserFunctions';
import { recoverPassword } from './recoveryPasswordService';
import { withStyles } from 'material-ui';

const styles = theme => ({
    recoverPassword: theme.palette.recoverPassword
});

class PasswordReminder extends OLYWebPageComponent {
    constructor(props) {
        super(props);

        this.pageName = 'PasswordReminder';
        this.pageTitle = props.t('PAGE_TITLES.' + this.pageName);
        this.pageReference = 'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/689537084/UI+-+Recuperar+Contrase+a';


        this.state = {
            user: {
                user: ''
            },
            loading: false,
            failed: false,
            disableRequestButton: true
        };

        this.accountName = getAccountName().toLowerCase();
    }

    requestPassword = () => {
        this.setState({ loading: true, failed: false });
        recoverPassword(this.state.user)
            .then(response => {
                this.setState({
                    loading: false,
                    failed: false,
                    message: this.props.t('RECOVER_PASSWORD.REQUEST_PROCESSED')
                });
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    failed: true,
                    message: this.props.t('RECOVER_PASSWORD.ERROR_CHANGING_PASSWORD')
                });
            });
    };

    fieldGenerator = fieldname => {
        return {
            onChange: event => {
                let user = this.state.user;
                user[fieldname] = event.target.value;
                const disable = user[fieldname].length === 0;
                this.setState({ user, disableRequestButton: disable });
            },
            value: this.state.user[fieldname]
        };
    };

    render() {
        const { classes, t } = this.props;
        return (
            <div className={'mainbody'}>
                <div className={'loginbox'}>
                    <img
                        src={`assets/${this.accountName}/logo-login.png`}
                        className={'centered'}
                        alt="logo"
                        style={{ marginBottom: '1rem', width: '320px' }}
                    />
                    <Card>
                        <CardHeader
                            title={t('RECOVER_PASSWORD.RECOVER_PASSWORD')}
                            subheader={t('RECOVER_PASSWORD.PLEASE_ENTER_USER')}
                        />
                        <CardContent>
                            <FormControl fullWidth error={this.state.failed}>
                                <InputLabel htmlFor="user">{t('COMMON.USER')}</InputLabel>
                                <Input
                                    id="user"
                                    type="user"
                                    startAdornment={<AccountBox />}
                                    {...this.fieldGenerator('user')}
                                />
                                <FormHelperText>{this.state.message}</FormHelperText>
                            </FormControl>
                        </CardContent>
                        <CardActions>
                            {this.state.loading ? (
                                <CircularProgress style={{ margin: 'auto' }} />
                            ) : (
                                <Button
                                    color="primary"
                                    style={{ width: '100%' }}
                                    onClick={this.requestPassword}
                                    disabled={this.state.disableRequestButton}
                                >
                                    {t('RECOVER_PASSWORD.RECOVER_PASSWORD_BUTTON').toUpperCase()}
                                </Button>
                            )}
                        </CardActions>
                    </Card>

                    <Button href="/" className={classes.recoverPassword}>
                        {t('RECOVER_PASSWORD.BACK_TO_LOGIN').toUpperCase()}
                    </Button>
                </div>
            </div>
        );
    }
}
export default translate('translations')(withStyles(styles)(PasswordReminder));


// WEBPACK FOOTER //
// ./src/components/PasswordReminder/PasswordReminder.js